import React, { useEffect, useState } from "react";
import MainBanner from "../../Components/Banner/MainBanner";
import Footer from "../../Components/Footer/Footer";
import Header from "../../Components/Header/Header";
import "../../assets/css/familymemberShip.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { arrow, dollar } from "../../constant";
import StripeForm from "../../Components/PaymentMethod/StripeForm";
import ActionButton from "../../Components/ActionBtn/ActionButton";
import { GrAddCircle } from "react-icons/gr";
import {
	bookMemberShipPost,
	GetMembership,
	PostMembershipById,
} from "../../network/Network";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";

function FamilyMembership() {
	const navigate = useNavigate();
	const [camping, setCamping] = useState();
	const Token = useSelector((state) => state?.AuthReducer?.token);
	const date = new Date().toLocaleString();
	const [loading, setLoading] = useState(false);
	const [btnLoading, setBtnLoading] = useState(false);
	const [familyCounter, setFamilyCounter] = useState(0);
	const [singleCamping, setSingleCamping] = useState();
	const [gardenMembership, setGardenMembership] = useState([]);
	const [extraMembers, setExtraMembers] = useState({
		regularPriceLimits: null,
		extraMembershipPrice: null,
	});
	const [memberDetails, setMemberDetails] = useState({
		full_name: null,
		email: null,
		contact: null,
		dob: null,
		age: null,
		address: null,
	});
	const [state, setState] = useState({
		membership_id: 10,
		is_family_membership: "",
		other_memberships_included: "",
		price: gardenMembership?.price,
		booking_date: "",
		booking_time: "",
	});

	const [age, setAge] = useState(null);

	const memberChangeInput = async (e, type) => {
		let { name, value } = e.target;
		if (type == "dob") {
			await calculateAge(e.target.value);
		}
		if (name == "age") {
			setMemberDetails({ ...memberDetails, [name]: age });
		} else setMemberDetails({ ...memberDetails, [name]: value });
	};

	const [familyMembers, setFamilyMembers] = useState([]);
	const styling = {
		marginTop: "10px",
		width: "100%",
	};
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	let [count, setCount] = useState([]);
	let [amount, setAmount] = useState(1);

	const [familyMembership, setFamilyMembership] = useState(null);

	const HandleClick = (e) => {
		e.preventDefault();
		let famly_check = [];
		famly_check = familyMembers.filter((item) => {
			if (item.age >= 6) {
				return item;
			}
		});
		// if (famly_check.length < 6 || memberDetails.age < 6) {
		if (memberDetails.age < 1) {
			if (
				!memberDetails.full_name ||
				!memberDetails.email ||
				!memberDetails.contact ||
				!memberDetails.dob ||
				!memberDetails.address
			) {
				toast.error("Please fill all fields");
				return;
			}
			if (
				memberDetails.full_name.length < 3 ||
				memberDetails.full_name.length > 17
			) {
				toast.error("Full name must be at least 3 to 17 characters");
				return;
			}
			if (
				memberDetails.address.length < 3 ||
				memberDetails.address.length > 30
			) {
				toast.error("Addresss must be at least 3 to 30 characters");
				return;
			} else if (
				!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
					memberDetails.email,
				)
			) {
				toast.error("Invalid email format");
				return;
			} else if (
				memberDetails.contact.length < 8 ||
				memberDetails.contact.length > 15
			) {
				toast.error("contact number must be atleast 8 digits to 15 digits");
				return;
			} else {
				let newArr = [...familyMembers].concat(memberDetails);
				setFamilyMembers(newArr);
				setMemberDetails({
					full_name: "",
					email: "",
					contact: "",
					dob: "",
					age: "",
					address: "",
				});
			}
		} else {
			toast.error("Age can't be less than 1");
		}
	};

	// Get Membership by id
	useEffect(() => {
		setLoading(true);
		PostMembershipById(10)
			.then((res) => {
				setLoading(false);
				setFamilyMembership(res?.data);
				const extraMemberships = {
					regularPriceLimits: res?.data?.no_of_member,
					extraMembershipPrice: res?.data?.extra_charges,
				};
				setExtraMembers(extraMemberships);
			})
			.catch((err) => {
				setLoading(false);
			});
	}, []);

	const deleteMember = (index) => {
		let arr = familyMembers.filter((item, i) => {
			return i != index;
		});
		setFamilyMembers(arr);
	};

	const PlaceOrderHandler = (e, stripe_token) => {
		e.preventDefault();
		setBtnLoading(true);
		if (!familyMembers?.[0]) {
			toast.error("Please add family memeber details");
			setBtnLoading(false);
		} else {
			const { regularPriceLimits, extraMembershipPrice } = extraMembers ?? {};
			const { price } = familyMembership ?? {};

			const result = (familyMembers?.length || 0) - (regularPriceLimits || 0);

			const updatedPrice =
				Math.abs(result) > 0 ? price * extraMembershipPrice : price;

			let sendData = {
				membership_id: state?.membership_id,
				family_member: familyMembers,
				price: familyMembership?.price,
				extra_charges: updatedPrice,
				_token: stripe_token,
				booking_date: date.slice(0, 9),
				booking_time: date.slice(11, 15),
				type: "membership",
				platform: "hoho",
			};
			bookMemberShipPost(sendData, Token)
				.then((res) => {
					setBtnLoading(false);
					navigate("/");
					toast.success("Family Membership booking has been done successfully");
				})
				.catch((err) => {
					toast.error(`${err?.response?.data?.message}`);
					setBtnLoading(false);
					// navigate('/');
				});
		}
	};

	useEffect(() => {
		if (state.other_memberships_included) {
			let value = camping?.filter((item) => {
				if (item?.type === "garden_tour") return item;
			});
			setSingleCamping(value?.[0]);
		}
	}, [state.other_memberships_included]);

	// Get Membership by id
	useEffect(() => {
		setLoading(true);
		PostMembershipById(10)
			.then((res) => {
				setLoading(false);
				setGardenMembership(res?.data);
			})
			.catch((err) => {
				setLoading(false);
			});
	}, []);

	useEffect(() => {
		setLoading(true);
		GetMembership()
			.then((res) => {
				setLoading(false);
				setCamping(res.data);
			})
			.catch((err) => {
				setLoading(false);
			});
	}, []);

	const calculateAge = (birthdate) => {
		const birthDate = new Date(birthdate);
		const currentDate = new Date();
		const ageInMilliseconds = currentDate - birthDate;
		const ageInYears = Math.floor(
			ageInMilliseconds / (365 * 24 * 60 * 60 * 1000),
		);
		setMemberDetails({ ...memberDetails, age: ageInYears });
		setAge(ageInYears);
	};

	return (
		<>
			<Header />
			<MainBanner name={familyMembership?.heading} />
			<section className="familymember-page">
				<div className="container">
					{loading ? (
						<Skeleton count={5} />
					) : (
						<div>
							<div className="Book_range_center">
								<h2 className="main-Title">1 Year Membership </h2>
								<h3 className="priceRate">
									<img src={dollar} className="mr-2" alt="" />
									{familyMembership?.price}
								</h3>
							</div>
							<p className="main-para">{familyMembership?.description}</p>
							<ActionButton />
							<div className="formContainer">
								<p className="sub-title">Booking Details</p>
								<div className="row">
									{/* <p className="members-para">Member 1</p> */}
									<div className="col-lg-6">
										<p className="sub-title-sm">Full Name</p>
										<input
											value={memberDetails.full_name}
											onChange={memberChangeInput}
											name="full_name"
											// onChange={(e) => { setMemberDetails({ ...memberDetails, fullName: e.target.value }) }}
											type="text"
											className="members-para"
										/>
									</div>
									<div className="col-lg-6">
										<p className="sub-title-sm">Email</p>
										<input
											value={memberDetails.email}
											// onChange={(e) => { setMemberDetails({ ...memberDetails, email: e.target.value }) }}
											onChange={memberChangeInput}
											name="email"
											type="text"
											className="members-para"
										/>
									</div>
									<div className="col-lg-6">
										<p className="sub-title-sm mt-3">Contact Number</p>
										<input
											onChange={memberChangeInput}
											value={memberDetails.contact}
											name="contact"
											// onChange={(e) => { setMemberDetails({ ...memberDetails, contactNo: e.target.value }) }}
											type="text"
											className="members-para"
										/>
									</div>
									<div className="col-lg-6">
										<p className="sub-title-sm mt-3">Date Of birth</p>
										<input
											onChange={(e) => {
												memberChangeInput(e, "dob");
											}}
											value={memberDetails.dob}
											name="dob"
											// onKeyDown={(e) => e.preventDefault()}
											// onkeydown="return false"
											// onChange={(e) => { setMemberDetails({ ...memberDetails, dateOfBirth: e.target.value }) }}
											type="date"
											className="members-para"
										/>
									</div>

									<div className="col-lg-6">
										<p className="sub-title-sm mt-3">Age</p>
										<input
											value={memberDetails.age}
											onChange={memberChangeInput}
											name="age"
											disabled={true}
											// onChange={(e) => { setMemberDetails({ ...memberDetails, age: e.target.value }) }}
											type="number"
											className="members-para"
										/>
									</div>

									<div className="col-lg-6">
										<p className="sub-title-sm mt-3">Address</p>
										<input
											value={memberDetails.address}
											onChange={memberChangeInput}
											name="address"
											// onChange={(e) => { setMemberDetails({ ...memberDetails, address: e.target.value }) }}
											type="text"
											className="members-para"
										/>
									</div>
								</div>
								<div className="col-lg-12 mt-4 pl-0">
									<div
										className="AddMemberform"
										style={{ cursor: "pointer" }}
										onClick={HandleClick}
									>
										<p>Add Member</p>
										<GrAddCircle className="icons-add" />
									</div>
								</div>
								<div className="row">
									{familyMembers?.map((item, index) => {
										return (
											<div className="col-lg-6 my-2 pos-rel">
												<i
													onClick={() => {
														deleteMember(index);
													}}
													className="fa fa-trash-o del_item_trash"
													aria-hidden="true"
												></i>
												<div className="card h-100">
													<div className="card-body">
														<div className="row">
															<div className="col-lg-12">
																<p className="main_icon_family">
																	{" "}
																	Member no {index + 1} detail :
																</p>
															</div>
															<div className="col-lg-5">
																<p className="label_icon_family">Name : </p>
															</div>
															<div className="col-lg-7">
																<span className="text_icon_family">
																	{item.full_name}
																</span>
															</div>
															<div className="col-lg-5">
																<p className="label_icon_family">Email : </p>
															</div>
															<div className="col-lg-7">
																<span className="text_icon_family">
																	{item.email}
																</span>
															</div>
															<div className="col-lg-5">
																<p className="label_icon_family">Phone : </p>
															</div>
															<div className="col-lg-7">
																<span className="text_icon_family">
																	{item.contact}
																</span>
															</div>
															<div className="col-lg-5">
																<p className="label_icon_family">
																	Date of Birth :{" "}
																</p>
															</div>
															<div className="col-lg-7">
																<span className="text_icon_family">
																	{item.dob}
																</span>
															</div>
															<div className="col-lg-5">
																<p className="label_icon_family">Age : </p>
															</div>
															<div className="col-lg-7">
																<span className="text_icon_family">{age}</span>
															</div>
														
															<div className="col-lg-5">
																<p className="label_icon_family">Address : </p>
															</div>
															<div className="col-lg-7">
																<span className="text_icon_family">
																	{item.address}
																</span>
															</div>
														</div>
													</div>
												</div>
											</div>
										);
									})}
								</div>

								<div className="col-lg-12 mt-4 pl-0">
									{Token ? (
										<>
											<p className="sub-title">Payment Details </p>
											<StripeForm
												styling={styling}
												paynow="SUBMIT"
												PaymentHandler={PlaceOrderHandler}
												loading={btnLoading}
											/>
										</>
									) : (
										<>
											<p className="sub-title">Payment Details </p>
											<div className="camping_btn">
												<button
													onClick={() => {
														navigate("/login");
													}}
													className="btn"
												>
													Sign In
													<img src={arrow} className="image-fluid pl-2" />
												</button>
												<button
													onClick={() => {
														navigate("/signup");
													}}
													className="btn secondbtn"
												>
													Create An Account
													<img src={arrow} className="image-fluid pl-2" />
												</button>
											</div>
										</>
									)}
								</div>
							</div>
						</div>
					)}
				</div>
			</section>
			<Footer />
		</>
	);
}

export default FamilyMembership;
